/**
 * Swiper Components
 */
export class SwiperComponents {
    constructor() {
        this.swipers = {
            clinicIntro: null,
            mainPofol: null,
            mainResource: null,
            subNav: null,
            beforeAfter: null,
            mainCelebrity: null,
            mainGallery: null,
        };
    }

    init() {
        this.initClinicIntro();
        this.initMainPofol();
        this.initMainResource();
        this.initSubNav();
        this.initBeforeAfter();
        this.initMainCelebrity();
        this.initMainGallery();
    }

    initClinicIntro() {
        const thumbSwiper = new Swiper(".thumb-swiper", {
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: { spaceBetween: 5, slidesPerView: 4 },
                768: { spaceBetween: 10, slidesPerView: 6 },
            },
        });

        this.swipers.clinicIntro = new Swiper(".control-swiper", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: { swiper: thumbSwiper },
        });
    }

    initMainPofol() {
        const el = document.querySelector("#main-pofol-swiper");
        if (!el) return;

        this.swipers.mainPofol = new Swiper(el, {
            slidesPerView: 4,
            spaceBetween: 24,
            navigation: {
                nextEl: ".no-main-pofol__button--next",
                prevEl: ".no-main-pofol__button--prev",
            },
            breakpoints: {
                320: { slidesPerView: 1.5 },
                544: { slidesPerView: 2.5 },
                768: { slidesPerView: 3.5 },
                1024: { slidesPerView: 4 },
            },
        });
    }

    initMainResource() {
        const el = document.querySelector("#main-resource-swiper");
        if (!el) return;

        this.swipers.mainResource = new Swiper(el, {
            slidesPerView: 4,
            spaceBetween: 24,
            breakpoints: {
                320: { slidesPerView: 1.5 },
                544: { slidesPerView: 2.5 },
                768: { slidesPerView: 1.5 },
                1024: { slidesPerView: 2.5 },
            },
        });
    }

    initSubNav() {
        const el = document.querySelector("#sub-nav-swiper");
        if (!el) return;

        const nav = el.closest("#sub-nav") || document.getElementById("sub-nav");
        if (!nav) return;

        this.swipers.subNav = new Swiper(el, {
            slidesPerView: "auto",
            spaceBetween: 8,
            speed: 280,
            touchRatio: 1,
            threshold: 8,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
            on: {
                init() {
                    const activeIndex = this.slides.findIndex((slide) =>
                        slide.classList.contains("--active")
                    );
                    if (activeIndex !== -1) {
                        this.slideTo(activeIndex, 0);
                    }
                },
            },
        });
    }

    initBeforeAfter() {
        const el = document.querySelector("#main-before-after-swiper");
        if (!el) return;

        this.swipers.beforeAfter = new Swiper(el, {
            slidesPerView: 1.5,
            spaceBetween: 24,
            width: null, // 명시적으로 null로 설정하여 자동 계산
            autoHeight: false,
            watchOverflow: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                    spaceBetween: 12,
                },
                544: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
                1640: {
                    slidesPerView: 1.5,
                    spaceBetween: 40,
                },
            },
            on: {
                init() {
                    // 초기화 후 슬라이드 너비 강제 재계산
                    this.update();
                },
            },
        });
    }

    initMainCelebrity() {
        const el = document.querySelector("#main-celebrity-swiper");
        if (!el) return;

        this.swipers.mainCelebrity = new Swiper(el, {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                hide: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                    slidesPerGroup: 1,
                    spaceBetween: 12,
                },
                544: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2.5,
                    slidesPerGroup: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 24,
                },
            },
        });
    }

    initMainGallery() {
        const el = document.querySelector("#main-gallery-swiper");
        if (!el) return;

        this.swipers.mainGallery = new Swiper(el, {
            slidesPerView: 2.5,
            spaceBetween: 20,
            speed: 1000,
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                hide: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                    spaceBetween: 12,
                },
                544: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 2.5,
                    spaceBetween: 24,
                },
            },
        });
    }
}
